import { getItem } from "./safeStorage";

/**
 * Applies the saved UI language to react-datepicker.
 *
 * react-datepicker is imported dynamically so that it, and the date-fns locale
 * data it drags along, stay out of the initial bundle. The public landing page
 * lives at "/" and is part of that bundle — an anonymous visitor reading
 * marketing copy has no use for a date picker.
 *
 * Failures are swallowed on purpose: the picker's locale is cosmetic and must
 * never take a page down with it.
 */
export default function setDatepickerLocale() {
  const language = getItem("i18nextLng");

  return import("react-datepicker")
    .then(({ setDefaultLocale }) => setDefaultLocale(language))
    .catch(() => {});
}
